import "./info.style.scss";
import { FormInfo } from "./components/FormInfo.view";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import { useEncrypt } from "../../../../hooks/useEncrypt";

export const InfoConvocatorias = () => {
  const routes = [
    { nombre: "Convocatorias" },
    { nombre: "Crear convocatoria" },
    { nombre: "Artistas" },
  ];
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  return (
    <div className="background-color-F7FBFF height-100">
      <div className="col-12">
        <div>
          <BreadCrumbAdmin routes={routes} />
        </div>
      </div>
      <Navegador
        idconvocatorias={idConvocatoria}
        activo="Información General"
      />
      <FormInfo />
    </div>
  );
};
